import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SuperAdminDeploymentsComponent } from './super-admin-deployments/super-admin-deployments.component';
import { SuperAdminHelpCenterDemoComponent } from './super-admin-help-center-demo/super-admin-help-center-demo.component';
import { SuperAdminTenantsComponent } from './super-admin-tenants/super-admin-tenants.component';
import { SuperAdminComponent } from './super-admin.component';

const routes: Routes = [
  {
    path: '',
    component: SuperAdminComponent,
    children: [
      {
        path: 'tenants',
        component: SuperAdminTenantsComponent,
      },
      {
        path: 'help-center-demo',
        component: SuperAdminHelpCenterDemoComponent,
      },
      {
        path: 'deployments',
        component: SuperAdminDeploymentsComponent,
      },
      {
        path: 'taxonomy',
        loadChildren: () =>
          import('./super-admin-taxonomy/super-admin-taxonomy.module').then((m) => m.SuperAdminTaxonomyModule),
      },
      {
        path: 'knowledge-gaps',
        loadChildren: () =>
          import('./super-admin-knowledge-gaps/super-admin-knowledge-gaps.module').then(
            (m) => m.SuperAdminKnowledgeGapsModule,
          ),
      },
      {
        path: '',
        redirectTo: 'tenants',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SuperAdminRoutingModule {}
